// extracted by mini-css-extract-plugin
export var messageSideLeft = "_qc-1";
export var stateContainer = "_qc-0";